import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Shield, Lock, Eye, FileText, CheckCircle, AlertCircle, Mail, Phone, MapPin } from 'lucide-react';
export const DataCompliancePage = () => {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-1476">
      <Header data-id="element-1477" />

      <main className="flex-grow" data-id="element-1478">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary-600 to-primary-700 text-white py-16" data-id="element-1479">
          <div className="container" data-id="element-1480">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1481">
              <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-1482">
                <Shield size={40} data-id="element-1483" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1484">
                Data Protection & Compliance
              </h1>
              <p className="text-xl text-primary-100" data-id="element-1485">
                Your privacy and data security are our top priorities. Learn how
                we protect your information.
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16" data-id="element-1486">
          <div className="container" data-id="element-1487">
            <div className="max-w-4xl mx-auto" data-id="element-1488">
              {/* Data Controller & Processor */}
              <div className="mb-16" data-id="element-1489">
                <div className="flex items-center gap-3 mb-6" data-id="element-1490">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1491">
                    <FileText size={24} className="text-primary-600" data-id="element-1492" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1493">
                    Kenya Data Controller & Processor
                  </h2>
                </div>

                <div className="prose prose-lg max-w-none" data-id="element-1494">
                  <p className="text-gray-600 mb-4" data-id="element-1495">
                    Geldhaus Africa Limited is registered as both a Data
                    Controller and Data Processor under the Kenya Data
                    Protection Act, 2019. We are committed to protecting your
                    personal data and ensuring compliance with all applicable
                    data protection regulations in Kenya.
                  </p>

                  <div className="bg-primary-50 border-l-4 border-primary-600 p-6 rounded-r-lg mb-6" data-id="element-1496">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1497">
                      Registration Details
                    </h3>
                    <ul className="space-y-2 text-gray-700" data-id="element-1498">
                      <li data-id="element-1499">
                        <strong data-id="element-1500">Company Name:</strong> Geldhaus Africa Limited
                      </li>
                      <li data-id="element-1501">
                        <strong data-id="element-1502">Data Protection Officer:</strong>{' '}
                        compliance@geldhaus.africa
                      </li>
                      <li data-id="element-1503">
                        <strong data-id="element-1504">
                          Office of the Data Protection Commissioner
                          Registration:
                        </strong>{' '}
                        DPR/2024/XXXXX
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* What Data We Collect */}
              <div className="mb-16" data-id="element-1505">
                <div className="flex items-center gap-3 mb-6" data-id="element-1506">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1507">
                    <Eye size={24} className="text-primary-600" data-id="element-1508" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1509">
                    What Data We Collect
                  </h2>
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-1510">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6" data-id="element-1511">
                    <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1512">
                      Personal Information
                    </h3>
                    <ul className="space-y-2 text-gray-600" data-id="element-1513">
                      <li className="flex items-start gap-2" data-id="element-1514">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1515" />
                        <span data-id="element-1516">Full name and identification details</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1517">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1518" />
                        <span data-id="element-1519">Contact information (phone, email, address)</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1520">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1521" />
                        <span data-id="element-1522">National ID and KRA PIN</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1523">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1524" />
                        <span data-id="element-1525">Employment and income information</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6" data-id="element-1526">
                    <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1527">
                      Financial Information
                    </h3>
                    <ul className="space-y-2 text-gray-600" data-id="element-1528">
                      <li className="flex items-start gap-2" data-id="element-1529">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1530" />
                        <span data-id="element-1531">Bank account details</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1532">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1533" />
                        <span data-id="element-1534">Credit history and credit bureau reports</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1535">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1536" />
                        <span data-id="element-1537">Asset information (vehicle logbooks, etc.)</span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1538">
                        <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1539" />
                        <span data-id="element-1540">Transaction and repayment history</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* How We Use Your Data */}
              <div className="mb-16" data-id="element-1541">
                <div className="flex items-center gap-3 mb-6" data-id="element-1542">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1543">
                    <Lock size={24} className="text-primary-600" data-id="element-1544" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1545">
                    How We Use Your Data
                  </h2>
                </div>

                <div className="space-y-4" data-id="element-1546">
                  <div className="bg-white border-l-4 border-primary-600 p-6 rounded-r-lg" data-id="element-1547">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1548">
                      Loan Processing & Assessment
                    </h3>
                    <p className="text-gray-600" data-id="element-1549">
                      We use your personal and financial information to assess
                      your loan application, determine creditworthiness, and
                      make lending decisions.
                    </p>
                  </div>

                  <div className="bg-white border-l-4 border-primary-600 p-6 rounded-r-lg" data-id="element-1550">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1551">
                      Credit Bureau Reporting
                    </h3>
                    <p className="text-gray-600" data-id="element-1552">
                      We share your credit information with licensed Credit
                      Reference Bureaus (CRBs) in Kenya as required by law to
                      maintain accurate credit records.
                    </p>
                  </div>

                  <div className="bg-white border-l-4 border-primary-600 p-6 rounded-r-lg" data-id="element-1553">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1554">
                      Communication & Customer Service
                    </h3>
                    <p className="text-gray-600" data-id="element-1555">
                      We use your contact information to communicate about your
                      loan, send updates, provide customer support, and share
                      relevant product information.
                    </p>
                  </div>

                  <div className="bg-white border-l-4 border-primary-600 p-6 rounded-r-lg" data-id="element-1556">
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1557">
                      Regulatory Compliance
                    </h3>
                    <p className="text-gray-600" data-id="element-1558">
                      We process your data to comply with legal obligations
                      including financial regulations, anti-money laundering
                      laws, and tax requirements.
                    </p>
                  </div>
                </div>
              </div>

              {/* Your Rights */}
              <div className="mb-16" data-id="element-1559">
                <div className="flex items-center gap-3 mb-6" data-id="element-1560">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1561">
                    <Shield size={24} className="text-primary-600" data-id="element-1562" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1563">
                    Your Data Protection Rights
                  </h2>
                </div>

                <div className="bg-gradient-to-br from-primary-50 to-white border-2 border-primary-200 rounded-xl p-8" data-id="element-1564">
                  <p className="text-gray-600 mb-6" data-id="element-1565">
                    Under the Kenya Data Protection Act, 2019, you have the
                    following rights:
                  </p>

                  <div className="space-y-4" data-id="element-1566">
                    <div className="flex items-start gap-3" data-id="element-1567">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1568" />
                      <div data-id="element-1569">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1570">
                          Right to Access
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1571">
                          Request access to your personal data we hold
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3" data-id="element-1572">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1573" />
                      <div data-id="element-1574">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1575">
                          Right to Correction
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1576">
                          Request correction of inaccurate or incomplete data
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3" data-id="element-1577">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1578" />
                      <div data-id="element-1579">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1580">
                          Right to Deletion
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1581">
                          Request deletion of your data (subject to legal
                          retention requirements)
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3" data-id="element-1582">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1583" />
                      <div data-id="element-1584">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1585">
                          Right to Object
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1586">
                          Object to processing of your data for specific
                          purposes
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3" data-id="element-1587">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1588" />
                      <div data-id="element-1589">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1590">
                          Right to Data Portability
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1591">
                          Request transfer of your data to another service
                          provider
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3" data-id="element-1592">
                      <CheckCircle size={20} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1593" />
                      <div data-id="element-1594">
                        <h4 className="font-bold text-gray-900 mb-1" data-id="element-1595">
                          Right to Lodge a Complaint
                        </h4>
                        <p className="text-gray-600 text-sm" data-id="element-1596">
                          File a complaint with the Office of the Data
                          Protection Commissioner
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Data Security */}
              <div className="mb-16" data-id="element-1597">
                <div className="flex items-center gap-3 mb-6" data-id="element-1598">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1599">
                    <Lock size={24} className="text-primary-600" data-id="element-1600" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1601">
                    Data Security Measures
                  </h2>
                </div>

                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1602">
                  <p className="mb-4" data-id="element-1603">
                    We implement robust technical and organizational security
                    measures to protect your personal data:
                  </p>

                  <ul className="space-y-3" data-id="element-1604">
                    <li className="flex items-start gap-2" data-id="element-1605">
                      <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1606" />
                      <span data-id="element-1607">End-to-end encryption for data transmission</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1608">
                      <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1609" />
                      <span data-id="element-1610">Secure data storage with access controls</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1611">
                      <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1612" />
                      <span data-id="element-1613">
                        Regular security audits and vulnerability assessments
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1614">
                      <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1615" />
                      <span data-id="element-1616">
                        Staff training on data protection and confidentiality
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1617">
                      <CheckCircle size={18} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-1618" />
                      <span data-id="element-1619">
                        Incident response and breach notification procedures
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Data Retention */}
              <div className="mb-16" data-id="element-1620">
                <div className="flex items-center gap-3 mb-6" data-id="element-1621">
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1622">
                    <AlertCircle size={24} className="text-primary-600" data-id="element-1623" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900" data-id="element-1624">
                    Data Retention
                  </h2>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6" data-id="element-1625">
                  <p className="text-gray-600 mb-4" data-id="element-1626">
                    We retain your personal data only for as long as necessary
                    to fulfill the purposes for which it was collected,
                    including:
                  </p>
                  <ul className="space-y-2 text-gray-600" data-id="element-1627">
                    <li className="flex items-start gap-2" data-id="element-1628">
                      <span className="font-semibold text-gray-900" data-id="element-1629">
                        Active Loans:
                      </span>
                      <span data-id="element-1630">
                        Duration of the loan plus 7 years as required by law
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1631">
                      <span className="font-semibold text-gray-900" data-id="element-1632">
                        Declined Applications:
                      </span>
                      <span data-id="element-1633">
                        Up to 2 years for regulatory and audit purposes
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1634">
                      <span className="font-semibold text-gray-900" data-id="element-1635">
                        Marketing Data:
                      </span>
                      <span data-id="element-1636">
                        Until you withdraw consent or request deletion
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Contact Information */}
              <div className="bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-2xl p-8" data-id="element-1637">
                <h2 className="text-2xl font-bold mb-4" data-id="element-1638">
                  Contact Our Data Protection Officer
                </h2>
                <p className="text-primary-100 mb-6" data-id="element-1639">
                  For any questions about how we handle your data, to exercise
                  your rights, or to file a complaint:
                </p>
                <div className="space-y-3" data-id="element-1640">
                  <p className="flex items-center gap-2" data-id="element-1641">
                    <Mail size={20} data-id="element-1642" />
                    <a href="mailto:compliance@geldhaus.africa" className="hover:underline" data-id="element-1643">
                      compliance@geldhaus.africa
                    </a>
                  </p>
                  <p className="flex items-center gap-2" data-id="element-1644">
                    <Phone size={20} data-id="element-1645" />
                    <a href="tel:+254100254254" className="hover:underline" data-id="element-1646">
                      +254 100 254 254
                    </a>
                  </p>
                  <p className="flex items-start gap-2" data-id="element-1647">
                    <MapPin size={20} className="flex-shrink-0 mt-1" data-id="element-1648" />
                    <span data-id="element-1649">Nairobi, Kenya</span>
                  </p>
                </div>
              </div>

              {/* Office of Data Protection Commissioner */}
              <div className="mt-8 bg-gray-50 border-2 border-gray-200 rounded-xl p-6" data-id="element-1650">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-1651">
                  Office of the Data Protection Commissioner
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-1652">
                  If you are not satisfied with our response, you have the right
                  to lodge a complaint with:
                </p>
                <div className="text-gray-700" data-id="element-1653">
                  <p className="font-semibold" data-id="element-1654">
                    Office of the Data Protection Commissioner
                  </p>
                  <p data-id="element-1655">Nairobi, Kenya</p>
                  <p data-id="element-1656">
                    Website:{' '}
                    <a href="https://www.odpc.go.ke" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline" data-id="element-1657">
                      www.odpc.go.ke
                    </a>
                  </p>
                  <p data-id="element-1658">
                    Email:{' '}
                    <a href="mailto:info@odpc.go.ke" className="text-primary-600 hover:underline" data-id="element-1659">
                      info@odpc.go.ke
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1660" />
    </div>;
};